import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { push } from 'react-router-redux'
import { Field, FieldArray, reduxForm, SubmissionError } from 'redux-form'

import { addCustomer } from '../actions/customers'
import { renderInputField, renderTextAreaField, renderSelectField } from '../utils/forms'

import '../styles/CustomerDetailsView.css'
import { CURRENCIES } from '../utils/currency';

class CustomerAddForm extends React.Component {
  constructor(props) {
    super(props)

    this.submit = this.submit.bind(this);
    this.renderItems = this.renderItems.bind(this);
  }

  submit(props) {

    props.Executor = this.props.fullname

    return this.props.addCustomer(props)
      .then(response => {
        if (response.error) {
          throw new SubmissionError({
            _error: response.error.message,
            ...response.error.fields
          })
        }

        return response
      })
  }

  renderItems(props) {
    const { fields } = props;

    return (
      <div>
        <div className="table-responsive">
          <table className="table table-sm table-stripped">
            <thead className="thead-dark">
              <tr>
                <th scope="col">Artículo</th>
                <th scope="col">Comisión Cliente (%)</th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {fields.map((member, index) => (
                <tr key={index}>
                  <td>
                    <Field
                      name={`${member}.item`}
                      component={renderSelectField}
                    >
                      <option value="">Selecciona un artículo...</option>
                      <option value="VWPACK" key="VWPACK">VWPACK</option>
                      <option value="VWLAY" key="VWLAY">VWLAY</option>
                      <option value="VWGO" key="VWGO">VWGO</option>
                      <option value="VWCHARGER" key="VWCHARGER">VWCHARGER</option>
                    </Field>
                  </td>
                  <td>
                    <Field
                      name={`${member}.comission`}
                      type="text"
                      component={renderInputField}
                    />
                  </td>
                  <td>
                    <button
                      className="btn btn-danger mr-1"
                      type="button"
                      onClick={() => fields.remove(index)}
                    >
                      <i className="fas fa-trash mr-1"></i>
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        <div className="text-right">
          <button
            className="btn bg-vw-light text-white"
            type="button"
            onClick={() => fields.push({})}
          >
            <i className="fas fa-plus mr-1"></i>
            Añadir
          </button>
        </div>
      </div>
    )
  }

  render() {
    const { error, pristine, submitting, handleSubmit } = this.props

    return (
      <form onSubmit={handleSubmit(this.submit)}>
        {/* Header */}
        <div className="cust-form-header">
          <div className="cust-form-header-content">
            <div className="cust-form-header-text">
              <h1>
                <i className="fas fa-user-plus mr-3"></i>
                <span className="text-vw-dark">NUEVO </span>
                <span className="text-vw-light">CLIENTE</span>
              </h1>
            </div>
          </div>
        </div>

        <div className="cust-tab-grid">

          {/* IDENTIFICACIÓN */}
          <div className="cust-form-section">
            <div className="cust-form-section-header"><i className="fas fa-user mr-2"></i>Identificación</div>
            <Field name="Fullname"
              type="text"
              component={renderInputField}
              label="Nombre completo" />
            <Field name="Contact_person"
              type="text"
              component={renderInputField}
              label="Persona de contacto" />
            <Field name="Email"
              type="text"
              component={renderInputField}
              label="E-mail" />
            <Field name="Password"
              type="password"
              component={renderInputField}
              label="Password" />
            <Field name="Phone"
              type="text"
              component={renderInputField}
              label="Teléfono 1" />
            <Field name="Phone2"
              type="text"
              component={renderInputField}
              label="Teléfono 2" />
            <Field name="Fax"
              type="text"
              component={renderInputField}
              label="Fax" />
            <Field name="Web"
              type="text"
              component={renderInputField}
              label="Web" />
          </div>

          {/* UBICACIÓN */}
          <div className="cust-form-section">
            <div className="cust-form-section-header"><i className="fas fa-map-marker-alt mr-2"></i>Ubicación</div>
            <Field name="Address"
              type="text"
              component={renderTextAreaField}
              label="Dirección" />
            <Field name="PostalCode"
              type="text"
              component={renderInputField}
              label="Código Postal" />
            <Field name="City"
              type="text"
              component={renderInputField}
              label="Ciudad" />
            <Field name="Province"
              type="text"
              component={renderInputField}
              label="Provincia" />
            <Field name="Country"
              component={renderSelectField}
              label="País">
              <option value="">Selecciona un país...</option>
              <option value="España">España</option>
              <option value="Francia">Francia</option>
              <option value="Italia">Italia</option>
              <option value="Chequia">Chequia</option>
            </Field>
          </div>

          {/* CONFIGURACIÓN */}
          <div className="cust-form-section">
            <div className="cust-form-section-header"><i className="fas fa-sliders-h mr-2"></i>Configuración</div>
            <Field name="Type"
              component={renderSelectField}
              label="Tipo">
              <option value="">Selecciona un tipo de usuario...</option>
              <option value="GENERAL">GENERAL</option>
              <option value="GROUP">GRUPO</option>
            </Field>
            <Field name="Category"
              component={renderSelectField}
              label="Categoria">
              <option value="">Selecciona una categoria...</option>
              <option value="BIGPLAYER">Big player</option>
              <option value="AWATERPARK">A Waterpark</option>
              <option value="BWATERPARK">B Waterpark</option>
              <option value="CWATERPARK">C Waterpark</option>
            </Field>
            <Field name="Group"
              component={renderSelectField}
              label="Grupo al que pertenece">
              <option value="">Selecciona un grupo...</option>
              <option value="ASPRO">ASPRO PARKS</option>
              <option value="GRPR">GRUPO PARQUES REUNIDOS</option>
              <option value="SANTAMARIA">GRUPO SANTAMARIA</option>
              <option value="ISLAMAGICA">GRUPO ISLA MAGICA</option>
            </Field>
            <Field name="Language"
              type="text"
              component={renderInputField}
              label="Idioma" />
            <Field name="Currency" component={renderSelectField} label="Moneda">
              {CURRENCIES.map((c) => (
                <option value={c.code} key={c.code}>{`${c.code} - ${c.name} (${c.symbol})`}</option>
              ))}
            </Field>
            <Field name="Notes"
              type="text"
              component={renderTextAreaField}
              label="Notas" />
          </div>

          {/* FACTURACIÓN */}
          <div className="cust-form-section">
            <div className="cust-form-section-header"><i className="fas fa-file-invoice-dollar mr-2"></i>Facturación</div>
            <Field name="Invoice_taxid"
              type="text"
              component={renderInputField}
              label="NIF/CIF" />
            <Field name="Invoice_tax"
              type="text"
              component={renderInputField}
              label="IVA aplicable (%)" />
            <Field name="Social_name"
              type="text"
              component={renderInputField}
              label="Razón social" />
            <Field name="Invoice_address"
              type="text"
              component={renderTextAreaField}
              label="Dirección de facturación" />
          </div>

          {/* NEGOCIO */}
          <div className="cust-form-section">
            <div className="cust-form-section-header"><i className="fas fa-briefcase mr-2"></i>Modelo de Negocio</div>
            <Field name="BusinessModel"
              component={renderSelectField}
              label="Modelo">
              <option value="">Selecciona un modelo...</option>
              <option value="REVENUE SHARE">REVENUE SHARE</option>
              <option value="SPACE RENTAL">SPACE RENTAL</option>
              <option value="SALE">VENTA</option>
              <option value="RENTAL">ALQUILER</option>
            </Field>
            <Field name="SpaceRentalAlquiler"
              component={renderInputField}
              type="text"
              label="Alquiler Anual" />
          </div>

          {/* SAP */}
          <div className="cust-form-section">
            <div className="cust-form-section-header"><i className="fas fa-industry mr-2"></i>SAP</div>
            <Field
              name="SAP.Model"
              component={renderSelectField}
              label="Modelo">
              <option value="">Selecciona un modelo...</option>
              <option value="VC">VENTAS CONTADO (Punto de Venta)</option>
              <option value="CV">COMISION VENTA (Solicitud Factura)</option>
            </Field>
            <Field
              name="SAP.CompanyID"
              component={renderSelectField}
              label="CompanyID">
              <option value="">Selecciona una empresa...</option>
              <option value="ES1000">ES1000</option>
              <option value="IT1000">IT1000</option>
            </Field>
            <Field
              name="SAP.CountryCode"
              component={renderSelectField}
              label="CountryCode">
              <option value="">Selecciona un código de país...</option>
              <option value="ES">ESPAÑA</option>
              <option value="IT">ITALIA</option>
              <option value="EU">EUROPA</option>
            </Field>
            <Field name="SAP.ClientID"
              type="text"
              component={renderInputField}
              label="ClientID" />
            <Field
              name="SAP.SiteID"
              type="text"
              component={renderInputField}
              label="SiteID" />
            <Field
              name="SAP.TaxCountryCode"
              type="text"
              component={renderInputField}
              label="TaxCountryCode" />
            <Field
              name="SAP.TaxationCharacteristicsCode"
              type="text"
              component={renderInputField}
              label="TaxationCharacteristicsCode" />
            <Field
              name="SAP.InventoryManagedLocationID"
              type="text"
              component={renderInputField}
              label="InventoryManagedLocationID" />
            <Field
              name="SAP.LogisticsAreaID"
              type="text"
              component={renderInputField}
              label="LogisticsAreaID" />
            <Field
              name="SAP.TaxRegionCode"
              type="text"
              component={renderInputField}
              label="TaxRegionCode" />
          </div>

          {/* ARTÍCULOS */}
          <div className="cust-form-section">
            <div className="cust-form-section-header"><i className="fas fa-shopping-cart mr-2"></i>Artículos</div>
            <FieldArray name="Items" component={this.renderItems} />
          </div>

        </div>

        {error && <div className="alert alert-danger mt-3">{error}</div>}

        {/* Actions */}
        <div className="cust-form-actions d-flex justify-content-end align-items-center">
          <button className="cust-admin-btn secondary mr-2" type="button"
            onClick={() => this.props.push('/customers')}>
            <i className="fas fa-times"></i><span>Cancelar</span>
          </button>
          <button className={`cust-admin-btn primary${(pristine || submitting) ? ' is-disabled' : ''}`}
            type="submit"
            disabled={pristine || submitting}>
            <i className="fas fa-save"></i><span>Guardar</span>
          </button>
        </div>
      </form>
    )
  }
}

CustomerAddForm = reduxForm({
  form: 'CustomerAddForm',
  enableReinitialize: true,
  onSubmitSuccess: (result, dispatch, props) => {
    props.push(`/customers/${result.response._id}`)
  }
})(CustomerAddForm)

const mapStateToProps = state => ({
  auth: state.auth,
  role: state.auth.role,
  type: state.auth.type,
  fullname: state.auth.fullname,
})

const mapDispatchToProps = dispatch => ({
  addCustomer: bindActionCreators(addCustomer, dispatch),
  push: bindActionCreators(push, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CustomerAddForm)
